export const ROLES = {
  org_admin: {
    label: 'Organisation Admin',
    value: 'org_admin',
    description: 'Manage organization settings, users, and entity access',
  },
  ent_admin: {
    label: 'Entity Admin',
    value: 'ent_admin',
    description: 'Manage entity settings and users. Restricted to one entity',
  },
  member: {
    label: 'Member',
    value: 'member',
    description: 'Basic access to assigned entities and features',
  },
};

export const ROLES_LIST = Object.values(ROLES);
